import { getLang } from "../functions";

document.addEventListener("DOMContentLoaded", () => {
  if (typeof zE !== "undefined") {
    let lang = getLang;

    // We don't have a `pt` language configured in Zendesk, what it currently
    // uses is `pt-br` so we need to set it
    if (lang == 'pt') {
      lang = 'pt-br';
    }

    zE("webWidget", "setLocale", lang);
  }
});
